module.exports = __webpack_public_path__ + "img/menu_bons.e9389941.svg";